import { useCallback, useState } from 'react';

type UserLoading = {
  globalLoading: boolean;
  loadingTip?: string;
};

export default function useUserLoadingModel() {
  const [userLoading, handleSetUserLoading] = useState<UserLoading>({ globalLoading: false });

  const setUserLoading = useCallback((userLoadingState: UserLoading) => {
    if (userLoadingState.globalLoading === false) {
      userLoadingState.loadingTip = undefined;
    }
    handleSetUserLoading(userLoadingState);
  }, []);

  return {
    userLoading,
    setUserLoading,
  };
}
